import { ObservablePropType } from "../ObservablePropType";
class REFERENCE extends ObservablePropType {
  ModelType = null;
  ref = null;
  constructor(parent, value, { modelType } = {}) {
    super(parent, value);
    this.ModelType = modelType;

    this.watch(() => {
      this.fetchRef(true);
    });
    this.fetchRef();
  }
  constructorName = "REFERENCE";
  loadCallbacks = [];
  onLoad(cb) {
    this.loadCallbacks.push(cb);
  }
  loadedRef() {
    while (this.loadCallbacks.length) {
      const cb = this.loadCallbacks.shift();
      cb(this.ref);
    }
  }
  getRef() {
    if (this.value && this.ref === null) this.fetchRef();
    return this.ref;
  }
  async asyncGetRef() {
    if (this.ref) return this.ref;

    return new Promise(async (resolve, reject) => {
      this.onLoad(resolve);
      if (this.value && this.ref === null) this.fetchRef();
    });
  }
  fetchRef(force = false) {
    if (this.value && (force || !this.ref)) {
      if (window.ModelStore) {
        window.ModelStore.fetch(
          { [this.ModelType]: this.value },
          (refModel) => {
            if (refModel[this.ModelType]) {
              this.ref = refModel[this.ModelType];
              this.loadedRef();
              // this.changed()
              // console.log(this.ref)
            }
          }
        );
      }
    } else {
      this.ref = null;
    }
  }
  /* Set the value and parse */
  set(value, preventEvent) {
    if (value && value._id) value = value._id.valueOf();
    const oldValue = this.value;
    const newValue = this.parse(
      value && value.valueOf ? value.valueOf() : value
    );
    this.value = newValue;
    if (newValue !== oldValue) {
      this.ref = null;
      if (!preventEvent) this.changed();
    }
  }
  /* Called by an update received from the server */
  update(value) {
    const oldValue = this.value;
    const newValue = this.parse(
      value && value.valueOf ? value.valueOf() : value
    );
    this.value = newValue;
    if (newValue !== oldValue) {
      this.ref = null;
      this.changed(true);
    }
  }
  element = "<vs-input></vs-input>";
  parse(value) {
    return value != null ? value : null;
  }
  toJSON() {
    return this.value;
  }
  get() {
    return this.value && this.value.valueOf();
  }
}

export default REFERENCE;
